// Shared by facilities--drawer-frame and facilities--frame-prefetch (CONEK-7405).
//
// Each facilities admin drawer frame has an inert sibling
// `<template id="<frame id>_pristine">` holding what the frame should show when
// nothing has been typed or fetched into it: the fresh Add form for the Add
// drawer, a skeleton of the form for the Edit drawer. Template content is not
// part of the document, so its ids never collide with a live form and Stimulus
// does not connect inside it; Stimulus (Tom Select, the location cascade)
// connects on the clone once it is inserted.

// Puts the frame back to its pristine content. Returns false when the frame
// has no template, so the caller can decide what "empty" means instead.
export function restorePristine(frame) {
  const pristine = document.getElementById(`${frame.id}_pristine`)
  const freshFrame = pristine?.content?.getElementById(frame.id)
  if (!freshFrame) return false

  frame.replaceChildren(...freshFrame.cloneNode(true).childNodes)
  return true
}

// Turbo keeps a frame's `src` attribute exactly as written, so normalise it
// before comparing it with an absolute `href`.
export function frameSource(frame) {
  const src = frame.getAttribute("src")
  return src ? new URL(src, window.location.href).href : null
}

// A modified click (new tab, new window, download) must reach the browser
// untouched: no drawer, no prevented default.
export function isModifiedClick(event) {
  return (
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey ||
    event.button > 0
  )
}
